module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAADeSURBVDiNY2CgEDD+r9FxoMQAFgaG//uPv+di+E+GZkvBbwwsDAwMDGmXpRl4WP6RpPnLHyaGczZ3IAYwMDAwfP7DRJIBjFAaq65gyU8MhYpvGPhZ/xI0CKsB3Mz/GJJl3zPsNntA0CC87uaCGrTL7AFDnsJbBjZGzKAm6PF//xkZznzgZNj7hofh139GDHkWLHoYGBgYGH7/Y2TY8YaHYeYjYYYH31hxWoDVgBPvuRjcXikwvP6F03z8Btz6ykZQIwyQFvlIABacLAwMDO8u2d1m+I8lgAjajiVW6A8Afv49uP7y1egAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/App/img/youtube_video.png
// module id = 626
// module chunks = 0